// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__p7T4x","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2XQUR","obliqueLine":"membershipbadge_obliqueLine__3i2to"};